import { Contacto } from './contacto';
export class Empresa {
  	_id: string;
	descripcion: string;
	direccion: string;
	estado: boolean;
	provincia: string;
	localidad: string;
	logo:any;
	contacto: Contacto[];
	plan: string;
	limitacionSMS: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/empresa/empresa.ts